import React from 'react';
import { NavLink } from 'react-router-dom';

const Navigation = () => {
    return (
        <nav>
            <ul style={{display: 'flex', listStyle: 'none', justifyContent: 'center', padding: 0}}>
                <li style={{marginRight: '20px'}}><NavLink to="/" exact activeClassName="active"
                                                           style={{color: 'white'}}>Home</NavLink></li>
                <li style={{marginRight: '20px'}}><NavLink to="/placas" activeClassName="active"
                                                           style={{color: 'white'}}>Conexão Placas</NavLink></li>
                <li style={{marginRight: '20px'}}><NavLink to="/regras" activeClassName="active"
                                                           style={{color: 'white'}}>Regras</NavLink></li>
                <li style={{marginRight: '20px'}}><NavLink to="/contato" activeClassName="active"
                                                           style={{color: 'white'}}>Contato</NavLink></li>
                <li style={{marginRight: '20px'}}><NavLink to="/placaslead" activeClassName="active"
                                                           style={{color: 'white'}}></NavLink></li>
                <li style={{marginRight: '20px'}}><NavLink to="/clublead" activeClassName="active"
                                                           style={{color: 'white'}}></NavLink></li>
                {/* Adicione mais links conforme necessário */}
            </ul>
        </nav>
    );
};

export default Navigation;
